<template>
    <div>
        <v-data-table test-tag="tag-66"
            dense
            :loading="loading"
            :headers="headers"
            :items="guests"
            :items-per-page="$store.getters.guests.per_page"
            :server-items-length="$store.getters.guests.total"
            :loading-text="$t('Загрузка...')"
            :no-data-text="$t('Список гостей пуст.')"
            :no-results-text="$t('По вашему запросу ничего не найдено.')"
            :footer-props="{
                'items-per-page-text': `${$t('Кол-во записей на странице: ')}`,
                'items-per-page-options': [25, 50, 100],
                'page-text': page_text
            }"
            :item-class="item => item.deleted ? 'deleted clickable-row' : 'clickable-row'"
            :options.sync="options"
            class="elevation-1"
        >
            <template v-slot:top>
                <div class="d-flex align-center">
                    <v-switch test-tag="tag-65"
                        v-model="deletedSelect"
                        class="pa-3 mt-0"
                        hide-details
                        :label="$t('Показать удаленные')"
                    >
                    </v-switch>
                    <v-spacer></v-spacer>
                    <v-btn test-tag="tag-63" color="primary" @click="$router.push({name: 'NewGuest'})"><T>Добавить гостя</T></v-btn>
                    <TextField
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        clearable
                        v-model="search"
                        @input="debounceInput"
                        class="mx-2 shrink"
                        style="height: 40px;"
                    />
                </div>
            </template>
            
            <template v-slot:item.black_list = {item}>
                <v-icon>{{ item.black_list ? 'mdi-check' : 'mdi-close'}}</v-icon>
            </template>
            
            <template v-slot:item.phones = {item}>
                <span v-if="!item.deleted"><PhoneFormatter v-model="item.phones[0].number"/></span>
            </template>
            
            <template v-slot:item.actions="{item}">
                <div v-if="!item.deleted">
                    <v-btn test-tag="tag-64" icon color="primary" small class="mr-2" link :to="'/guests/'+item.id"><v-icon>mdi-pencil</v-icon></v-btn>
                    <deleteGuestDialog :title="$t('Удаление гостя')" @onSubmit="deleteGuest(item.id)" icon>
                        <template #body>
                            <T>Гость {{ item.name }} будет удален.</T><br><T>Вы хотите удалить гостя?</T>
                        </template>
                    </deleteGuestDialog>
                </div>
            </template>
        </v-data-table>
        <router-view></router-view>
    </div>
</template>

<script>
import PhoneFormatter from '../common/PhoneFormatter.vue'
import deleteGuestDialog from './GuestInfo/deleteGuestDialog.vue'
import TextField from '../common/TextField.vue'
import _ from 'lodash'

export default{
    data:()=>({
        search: '',
        loading: false,
        page: 1,
        pageCount: 0,
        options:{
            page: 1,
            itemsPerPage: 25 
        },
        deletedSelect: false,
        search_results: undefined
    }),
    computed:{
        headers(){
            return [
                {
                    text: this.$t('id'),
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: this.$t('Имя'),
                    align: 'start',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: this.$t('Номер телефона'),
                    align: 'center',
                    sortable: false,
                    value: 'phones[0].number'
                },
                {
                    text: this.$t('E-mail'),
                    align: 'true',
                    sortable: true,
                    value: 'email'
                },
                {
                    text: this.$t('Доп. инфо'),
                    align: 'center',
                    sortable: false,
                    value: 'extra'
                },
                {
                    text: this.$t('Черный список'),
                    align: 'center',
                    sortable: true,
                    value: 'black_list'
                },
                {
                    text: '',
                    sortable: false,
                    value: 'actions'
                }
            ]
        },
        guests(){
            if(this.search){
                return this.search_results
            }
            return this.$store.getters.guests.items
        },
        page_text(){
            return `1-${this.guests?.length} ${this.$t('из')} ${this.$store.getters.guests.total}`
        }
    },
    methods:{
        async getData(){
            this.loading = true
            await this.$store.dispatch('getGuest', {...this.options, include_deleted: this.deletedSelect})
            this.loading = false
        },
        goToGuest(guest_id){
            this.$router.push(`guests/${guest_id}`)
        },
        async deleteGuest(guest_id){
            await this.$store.dispatch('deleteGuestById', guest_id)

            await this.$store.dispatch('getGuest', {...this.options, include_deleted: this.deletedSelect})
        },
        async searchGuests(query){
            this.loading = true

            if (([null, undefined, ''].includes(query))) {
                this.search_results = []
                this.$nextTick(() => this.search_results = undefined)
                this.loading = false
                return;
            }
                
            this.search_results = await this.$store.dispatch('apiQuery', {method: '/guest/search/like', body:{ query: query }})

            this.loading = false
        },
        debounceInput: _.debounce(function(val){
                this.searchGuests(val)
            }, 500
        )
    },
    async mounted(){
        await this.getData()
    },
    watch:{
        options: {
            handler(){
                this.getData()
            },
            deep: true
        },
        deletedSelect(){
            this.getData()
        },
    },
    components:{
        PhoneFormatter,
        deleteGuestDialog,
        TextField
    }
}
</script>

<style>
    .deleted{
        background-color: #eeeeee;
    }
</style>